import { render, staticRenderFns } from "./ExpenseSubCategoryEdit.vue?vue&type=template&id=4242db90&"
import script from "./ExpenseSubCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseSubCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports